import "./PendingOffers.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAllOffersQuery } from "../../../../API/Dashboard";
import { defaultParams } from "@utils/global.constants";
import useDebounce from "@hooks/useDebounce";
import storage from "@utils/storage";
import lefticon from "../../../../Assets/Images/lefticon.svg";
import righticon from "../../../../Assets/Images/righticon.svg";

type Offer = {
  uuid: string;
  lenderId: string;
  title: string;
  loanAmount: string;
  interestRate: string;
  loanDuration: string;
  termsAndConditions: string;
  status: string;
  isDeleted: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  applications: any[];
};

function PendingOffers() {
  const navigate = useNavigate();
  const Id = storage.getUser();
  const userId = Id.user.userId;
  const [params, setParams] = useState({ ...defaultParams, status: "approved", });
  const debouncedSearch = useDebounce(params.search, 500);

  const { isLoading, isFetching, data, error, isError } = useAllOffersQuery({
    userId,
    params,
  });

  const offers: Offer[] = data?.offers || [];

  const handleSort = (key: string) => {
    setParams(prev => ({
      ...prev,
      sortKey: key,
      sortOrder: prev.sortKey === key && prev.sortOrder === "DESC" ? "ASC" : "DESC",
      page: 1,
    }));
  };

  // Implement search filter logic
  // const filteredOffers = offers.filter(offer => {
  //   const isPending = offer.status?.toLowerCase() === "approved";
  //   const matchesSearch =
  //     offer.title.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
  //     offer.loanAmount.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
  //     offer.interestRate.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
  //     offer.loanDuration.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
  //     offer.status.toLowerCase().includes(debouncedSearch.toLowerCase());

  //   return isPending && matchesSearch;
  // });
  const filteredOffers = offers.filter(offer => {
    const matchesSearch =
      offer.title.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
      offer.loanAmount.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
      offer.interestRate.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
      offer.loanDuration.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
      offer.status.toLowerCase().includes(debouncedSearch.toLowerCase());

    return matchesSearch;
  });


  return (
    <>
      <div className="content">
        <div className="content-wrapper">
          <div className="title-block d-flex align-items-center justify-content-between common-searchbars-offrs all-offers-searchbar">
            <h5 className="m-0">Approved Offers</h5>
          </div>

          <div className="outer-box-wrapper">
            <div className="d-flex justify-content-between align-items-center mb-4">
                          <div className="input-btn-fields d-flex align-items-center">
              <div className="search-box">
                <div className="input-search position-relative">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    value={params.search}
                    onChange={(e) => {
                      const value = e.target.value;
                      setParams({ ...params, search: value });
                    }}
                  />
                  <div className="search-icon position-absolute">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13 13L9 9M1 5.66667C1 6.2795 1.12071 6.88634 1.35523 7.45252C1.58975 8.01871 1.93349 8.53316 2.36683 8.9665C2.80018 9.39984 3.31462 9.74358 3.88081 9.97811C4.447 10.2126 5.05383 10.3333 5.66667 10.3333C6.2795 10.3333 6.88634 10.2126 7.45252 9.97811C8.01871 9.74358 8.53316 9.39984 8.9665 8.9665C9.39984 8.53316 9.74358 8.01871 9.97811 7.45252C10.2126 6.88634 10.3333 6.2795 10.3333 5.66667C10.3333 5.05383 10.2126 4.447 9.97811 3.88081C9.74358 3.31462 9.39984 2.80018 8.9665 2.36683C8.53316 1.93349 8.01871 1.58975 7.45252 1.35523C6.88634 1.12071 6.2795 1 5.66667 1C5.05383 1 4.447 1.12071 3.88081 1.35523C3.31462 1.58975 2.80018 1.93349 2.36683 2.36683C1.93349 2.80018 1.58975 3.31462 1.35523 3.88081C1.12071 4.447 1 5.05383 1 5.66667Z"
                        stroke="#8F95A2"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div className="table-section rounded-3 overflow-auto">
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead className="table-light">
                    <tr>
                      <th onClick={() => handleSort("title")}>Title</th>
                      <th onClick={() => handleSort("loanAmount")}>Loan Amount</th>
                      <th onClick={() => handleSort("interestRate")}>Interest Rate</th>
                      <th onClick={() => handleSort("loanDuration")}>Loan Duration</th>
                      <th onClick={() => handleSort("createdAt")}>Offer Date</th>
                      {/* <th>No. of applications</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading || isFetching ? (
                      <tr>
                        <td colSpan={8} className="text-center py-4">Loading...</td>
                      </tr>
                    ) : isError ? (
                      <tr>
                        <td colSpan={8} className="text-center text-danger py-4">Error loading offers.</td>
                      </tr>
                    ) : filteredOffers?.length ? (
                      filteredOffers.map((offer, index) => (
                        <tr key={offer.uuid || index}>
                          <td>{offer.title}</td>
                          <td>£{Number(offer.loanAmount).toLocaleString()}</td>
                          <td>{offer.interestRate}%</td>
                          <td>{offer.loanDuration} months</td>
                          <td>
                            {new Intl.DateTimeFormat("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }).format(new Date(offer.createdAt))}
                          </td>
                          {/* <td>{String(offer.applications.length).padStart(1, '0')}</td> */}
                          <td>
                            <div className="action-icons d-flex">
                              <a className="edit" onClick={() => navigate("/app/update-offer", { state: { offerId: offer.uuid, from: location.pathname } })}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.76 18.8101H4.87L7.8 18.5401C8.21 18.5001 8.59 18.3201 8.88 18.0301L19.94 6.9701C20.46 6.4501 20.75 5.7601 20.75 5.0301C20.75 4.3001 20.46 3.6101 19.94 3.0901L19.23 2.3801C18.19 1.3401 16.38 1.3401 15.34 2.3801L13.93 3.7901L4.29 13.4301C4 13.7201 3.82 14.1001 3.79 14.5101L3.52 17.4401C3.49 17.8101 3.62 18.1701 3.88 18.4401C4.12 18.6801 4.43 18.8101 4.76 18.8101ZM17.29 3.0701C17.61 3.0701 17.93 3.1901 18.17 3.4401L18.88 4.1501C18.9968 4.26495 19.0896 4.40191 19.153 4.553C19.2163 4.70408 19.2489 4.86627 19.2489 5.0301C19.2489 5.19393 19.2163 5.35611 19.153 5.5072C19.0896 5.65829 18.9968 5.79525 18.88 5.9101L18 6.7901L15.53 4.3201L16.41 3.4401C16.65 3.2001 16.97 3.0701 17.29 3.0701ZM5.28 14.6501C5.28 14.5901 5.31 14.5401 5.35 14.5001L14.46 5.3801L16.93 7.8501L7.82 16.9601C7.82 16.9601 7.72 17.0301 7.67 17.0301L5.04 17.2701L5.28 14.6401V14.6501ZM22.75 22.0001C22.75 22.4101 22.41 22.7501 22 22.7501H2C1.59 22.7501 1.25 22.4101 1.25 22.0001C1.25 21.5901 1.59 21.2501 2 21.2501H22C22.41 21.2501 22.75 21.5901 22.75 22.0001Z"
                                    fill="#2C3E50"
                                  />
                                </svg>
                              </a>
                              <a className="view" onClick={() => navigate("/app/offer-applications", { state: { offerId: offer.uuid } })}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M23.8474 11.5331C23.633 11.2398 18.5244 4.35156 11.9999 4.35156C5.47528 4.35156 0.366464 11.2398 0.152292 11.5328C0.0533293 11.6684 0 11.8319 0 11.9998C0 12.1676 0.0533293 12.3311 0.152292 12.4667C0.366464 12.76 5.47528 19.6482 11.9999 19.6482C18.5244 19.6482 23.633 12.76 23.8474 12.4669C23.9465 12.3314 23.9999 12.1679 23.9999 12C23.9999 11.8321 23.9465 11.6686 23.8474 11.5331ZM11.9999 18.0658C7.19381 18.0658 3.03126 13.494 1.79906 11.9994C3.02967 10.5034 7.18349 5.93397 11.9999 5.93397C16.8057 5.93397 20.9679 10.505 22.2007 12.0004C20.97 13.4963 16.8162 18.0658 11.9999 18.0658Z"
                                    fill="#2C3E50"
                                  />
                                  <path
                                    d="M12.0002 7.25244C9.3826 7.25244 7.25293 9.38211 7.25293 11.9997C7.25293 14.6173 9.3826 16.747 12.0002 16.747C14.6178 16.747 16.7475 14.6173 16.7475 11.9997C16.7475 9.38211 14.6178 7.25244 12.0002 7.25244ZM12.0002 15.1645C10.255 15.1645 8.83538 13.7448 8.83538 11.9997C8.83538 10.2546 10.2551 8.83489 12.0002 8.83489C13.7453 8.83489 15.165 10.2546 15.165 11.9997C15.165 13.7448 13.7454 15.1645 12.0002 15.1645Z"
                                    fill="#2C3E50"
                                  />
                                </svg>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center py-4">No offers found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>

              </div>
              <div className="pagination justify-content-end">
                {data?.totalOffers > 0 && (
                  <div className="d-flex justify-content-end align-items-center mt-3 next-prev-btns mb-3">
                    <div>
                      {(() => {
                        const startItem = (data.currentPage - 1) * params.pageSize + 1;
                        const endItem = Math.min(startItem + params.pageSize - 1, data.totalOffers);
                        return `${startItem}-${endItem} of ${data.totalOffers}`;
                      })()}
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-secondary p-0 previous-btn-lender"
                        disabled={data.currentPage === 1}
                        onClick={() =>
                          setParams(prev => ({
                            ...prev,
                            page: prev.page - 1,
                          }))
                        }
                      >
                        <img src={lefticon} alt="" />

                      </button>

                      <button
                        className="btn btn-outline-secondary p-0 next-btn"
                        disabled={data.currentPage >= data.totalPages}
                        onClick={() =>
                          setParams(prev => ({
                            ...prev,
                            page: prev.page + 1,
                          }))
                        }
                      >
                        {/* <img src={righticon} alt="" /> */}
                        <img src={righticon} alt="" className="" />

                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PendingOffers;



